// extracted by css-extract-rspack-plugin
export default {"cls1":"MinimalStickyFooter-cls1_4Mp","cls2":"MinimalStickyFooter-cls2_QIB MinimalStickyFooter-cls1_4Mp"};